export const initialGroupValues = {
  title: '',
  budget: null,
};
